import React, { useEffect, createElement } from 'react';
import { SEO } from '../components/SEO';
import { breadcrumbSchema } from '../utils/structuredData';
import { ArrowLeftIcon, CheckCircleIcon, ClockIcon, VideoIcon } from 'lucide-react';
export function BookingPage() {
  useEffect(() => {
    // Load Calendly widget script
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  const breadcrumbs = [{
    name: 'Home',
    url: 'https://close-crm-agentur.de'
  }, {
    name: 'Strategy Call',
    url: 'https://close-crm-agentur.de/free-strategy-call'
  }];
  const structuredData = [breadcrumbSchema(breadcrumbs)];
  return <>
      <SEO title="Book a Free Strategy Call | Close CRM Consulting" description="Book your 30-minute free strategy call now. We analyze your sales situation and show concrete potential with Close CRM. ✓ 30 Min ✓ Video Call ✓ 100% Free" canonical="https://close-crm-agentur.de/free-strategy-call" structuredData={structuredData} data-id="element-336" data-mp="23wvc9kxv16os" />
      <div className="min-h-screen bg-[#0a0a0a]" data-id="element-337" data-mp="26jw52uxp13cf">
        {/* Header */}
        <header className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0a]/80 backdrop-blur-lg border-b border-white/5" data-id="element-338" data-mp="2bbxkgpq5ra6o">
          <nav className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8" data-id="element-339" data-mp="2g9fqo8csjbaz">
            <div className="flex items-center justify-center sm:justify-between h-14 sm:h-16 lg:h-20 gap-2 sm:gap-4" data-id="element-340" data-mp="2l9bv28peh4r2">
              <a href="/" className="flex items-center gap-1.5 sm:gap-2 flex-shrink-0" aria-label="Close CRM Agency Homepage" data-id="element-341" data-mp="2pax9hyhl1r3d">
                <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-[#0ea5e9] flex items-center justify-center flex-shrink-0" data-id="element-342" data-mp="uxxqrwhwogrv">
                  <span className="text-white font-bold text-xs sm:text-sm" data-id="element-343" data-mp="zx0oevvk3kpt">
                    C
                  </span>
                </div>
                <span className="text-white font-bold text-sm sm:text-base lg:text-lg whitespace-nowrap" data-id="element-344" data-mp="1y81uisgxrp4f">
                  Close CRM Agency
                </span>
              </a>
              <a href="/" className="hidden sm:flex items-center justify-center gap-2 text-gray-400 hover:text-white transition-colors text-sm flex-shrink-0" data-id="element-345" data-mp="2c5qe7wz9oq7w">
                <ArrowLeftIcon className="w-4 h-4" data-id="element-346" data-mp="2m3o2ull1gp11" />
                Back to Homepage
              </a>
            </div>
          </nav>
        </header>

        {/* Main Content */}
        <main className="pt-24 pb-16" data-id="element-347" data-mp="2uxj59lus01cz">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-348" data-mp="2qwz7qh6aivqb">
            {/* Intro Section */}
            <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-349" data-mp="34vyz3wl6toq6">
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-350" data-mp="34ue11wznznnk">
                Book a Free Strategy Call
              </h1>
              <p className="text-lg text-gray-400 mb-8" data-id="element-351" data-mp="3jk8sdltxjgtd">
                Book your 30-minute strategy call now. We analyze your current
                sales situation and show you concrete potential with Close CRM.
              </p>

              {/* Benefits */}
              <div className="grid sm:grid-cols-3 gap-6 mb-12" data-id="element-352" data-mp="3ek4cny0uiq47">
                <div className="flex flex-col items-center gap-2 p-4 rounded-xl bg-[#1a1a1a] border border-white/5" data-id="element-353" data-mp="3ei9omaua2hvw">
                  <div className="w-12 h-12 rounded-xl bg-[#0ea5e9]/10 flex items-center justify-center" data-id="element-354" data-mp="30qv41zkq28mq">
                    <ClockIcon className="w-6 h-6 text-[#0ea5e9]" data-id="element-355" data-mp="2qujpt41kn8pn" />
                  </div>
                  <span className="text-white font-medium" data-id="element-356" data-mp="2qsp1rgv070hc">30 Minutes</span>
                  <span className="text-gray-500 text-sm" data-id="element-357" data-mp="2vtwb3kcso7q4">
                    Focused Conversation
                  </span>
                </div>
                <div className="flex flex-col items-center gap-2 p-4 rounded-xl bg-[#1a1a1a] border border-white/5" data-id="element-358" data-mp="2lv73ckem43nl">
                  <div className="w-12 h-12 rounded-xl bg-[#0ea5e9]/10 flex items-center justify-center" data-id="element-359" data-mp="2esiegkiqdnjg">
                    <VideoIcon className="w-6 h-6 text-[#0ea5e9]" data-id="element-360" data-mp="29u75ec09fh2a" />
                  </div>
                  <span className="text-white font-medium" data-id="element-361" data-mp="251npv9i0ibuu">Video Call</span>
                  <span className="text-gray-500 text-sm" data-id="element-362" data-mp="203m76poi0ejw">
                    Zoom or Google Meet
                  </span>
                </div>
                <div className="flex flex-col items-center gap-2 p-4 rounded-xl bg-[#1a1a1a] border border-white/5" data-id="element-363" data-mp="1w2iwehlb58pj">
                  <div className="w-12 h-12 rounded-xl bg-emerald-500/10 flex items-center justify-center" data-id="element-364" data-mp="1r1d1qe837bdd">
                    <CheckCircleIcon className="w-6 h-6 text-emerald-400" data-id="element-365" data-mp="1m5nyo0wuzccb" />
                  </div>
                  <span className="text-white font-medium" data-id="element-366" data-mp="1h6kyatrtpuao">100% Free</span>
                  <span className="text-gray-500 text-sm" data-id="element-367" data-mp="3gh2o0glyj9rj">No Obligation</span>
                </div>
              </div>

              {/* What to expect */}
              <div className="text-left p-6 rounded-2xl bg-[#1a1a1a] border border-white/5 mb-12" data-id="element-368" data-mp="3k01rsyal2k29">
                <h2 className="text-xl font-bold text-white mb-4" data-id="element-369" data-mp="3o0lmzwbljdlr">
                  What you can expect:
                </h2>
                <ul className="space-y-3" data-id="element-370" data-mp="3st50yue74ar3">
                  {['Analysis of your current sales processes', 'Identification of optimization potential', 'Concrete recommendations for Close CRM', 'Answers to all your questions', 'Non-binding offer (if desired)'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-371" data-mp="3a0kk6bbrtw3n" data-mpi={index}>
                      <CheckCircleIcon className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-0.5" data-id="element-372" data-mp="3f0p4ydjppczo" />
                      <span className="text-gray-300" data-id="element-373" data-mp="pbwm8jerlr0l">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>

            {/* Calendly Widget */}
            <div className="max-w-4xl mx-auto" data-id="element-374" data-mp="4l9h7gqakxwx">
              <div className="rounded-2xl overflow-hidden border border-white/10 bg-[#1a1a1a]" data-id="element-375" data-mp="4o5er3y89kku">
                <div className="calendly-inline-widget" data-url="https://calendly.com/justus-kraft/crm-automatisierung-demo-website?hide_gdpr_banner=1&primary_color=0ea5e9" style={{
                minWidth: '320px',
                height: '700px'
              }} data-id="element-376" data-mp="3vug96h8qfn37" />
              </div>
              <p className="text-center text-sm text-gray-500 mt-6" data-id="element-377" data-mp="3d36xc1bhom8g">
                No suitable time available?{' '}
                <a href="mailto:justus@crm-kraft.de" className="text-[#0ea5e9] hover:underline" data-id="element-378" data-mp="3rs36k1pa85an">
                  Contact us directly
                </a>
              </p>
            </div>

            {/* Trust signals */}
            <div className="max-w-3xl mx-auto mt-16 p-8 rounded-2xl bg-gradient-to-r from-[#0ea5e9]/10 to-[#06b6d4]/10 border border-[#0ea5e9]/20 text-center" data-id="element-379" data-mp="2ual9o4aqk1yy">
              <p className="text-lg text-white font-medium mb-2" data-id="element-380" data-mp="1ejshq81goy51">
                Over 110 entrepreneurs already trust us
              </p>
              <p className="text-gray-400" data-id="element-381" data-mp="zwh7qakxhm71">
                On average, our clients achieve a 3.2x ROI within 6 months
              </p>
            </div>
          </div>
        </main>

        {/* Footer */}
        <footer className="bg-[#0a0a0a] border-t border-white/5 py-8" data-id="element-382" data-mp="1skcxswfzsfuu">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-383" data-mp="1xj6awnrda4uh">
            <p className="text-gray-600 text-sm" data-id="element-384" data-mp="1jjojs1qlmfhy">
              © {new Date().getFullYear()} Close CRM Agency. All rights
              reserved.
            </p>
          </div>
        </footer>
      </div>
    </>;
}